import { DefaultQueryParams, parseQuery } from '@pascal/pascal-core';
import { action, makeObservable, observable } from 'mobx';

class GameStore {
  isBetsClosed = false;

  isNotification = false;

  gameTypeId = null;

  notificationText = '';

  constructor() {
    makeObservable(this, {
      isBetsClosed: observable,
      gameTypeId: observable,
      notificationText: observable,
      isNotification: observable,
      setIsBetsClosed: action.bound,
      setGameTypeId: action.bound,
      setIsNotification: action.bound,
      setNotificationText: action.bound,
    });
  }

  setIsBetsClosed(arg) {
    this.isBetsClosed = arg;
  }

  setGameTypeId() {
    const { [DefaultQueryParams.GameTypeId]: gameTypeId } = parseQuery(window.location.search);
    this.gameTypeId = gameTypeId;
  }

  setNotificationText(text) {
    this.notificationText = text;
  }

  setIsNotification(bool) {
    this.isNotification = bool;
  }
}

export const gameStore = new GameStore();
